import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormHint } from "../../models/form.models";

// TODO: extend the ui-validation-hint to support templates and pass them from here
// https://quantive-inc.atlassian.net/browse/GVS-41401
@Component({
  selector: "form-hint",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormHintComponent implements FormHint {
  @Input() public content: string;
  @Input() public hideIcon?: boolean;
  @Input() public accented?: boolean;
  @Input() public type?: "success" | "error" | "warning" | "info";
}
